import React from 'react';
import { Box, Typography } from '@creditas-ui/react';

import { Link } from './FormFooter.styles';
import { useFormFooter } from './FormFooter.hook';

export const FormFooter = (): JSX.Element => {
  const { trackPrivacyLink, trackTermsLink } = useFormFooter();
  return (
    <Box padding="48px 0 24px">
      <Typography variant="bodySmRegular" color="neutral.60">
        <span>Al dar clic en Continuar aceptas nuestro </span>
        <Link
          as="a"
          href="https://www.creditas.mx/legal/aviso-privacidad"
          target="_blank"
          onClick={trackPrivacyLink}
        >
          Aviso de Privacidad
        </Link>
        <span>, </span>
        <Link
          as="a"
          href="https://www.creditas.mx/legal/terminos-condiciones"
          target="_blank"
          onClick={trackTermsLink}
        >
          Términos y Condiciones
        </Link>
        <span>.</span>
      </Typography>
    </Box>
  );
};
